import Page from './index';

export default { path: '/home/tenant/menu', component: Page };
